import React, { useLayoutEffect, useState } from 'react';
import {
  FcCalendar,
  FcAlarmClock,
  FcPhone,
  FcAbout,
  FcRating,
} from 'react-icons/fc';
import { FaBell } from 'react-icons/fa';
import { GiHamburgerMenu } from 'react-icons/gi';

import {
  Container,
  LogoContainer,
  LoggedUserContainer,
  SubMenuContainer,
} from './styles';

import NavbarLink from '../navbar-link';

import logo from 'resource/img/logo.png';
import useIsMobile from 'hooks/useIsMobile';
import useScrollDirection from 'hooks/useScrollDirection';
import useClickAway from 'hooks/useClickAway';
import SuperSubMenu from 'component/landing/super-submenu';
import SimpleSubMenu from 'component/landing/simple-submenu';
import IconList from 'component/landing/icon-list';
import MenuList from 'component/landing/menu-list';
import Notifications from 'component/landing/notifications';
import { useSubpoenaList } from 'component/subpoena/props';
import { Link } from 'react-router-dom';

const clippingItems = [
  {
    title: 'Intimações da AASP',
    description: 'Facilidade e integração para sua agenda',
    icon: FcRating,
    to: 'intimacoes-aasp',
  },
  {
    title: 'Lista de Recortes',
    description: 'Gerencie seus recortes',
    icon: FcCalendar,
    to: 'acompanhar-agenda',
  },
  {
    title: 'Novo Recorte',
    description: 'Inclua um novo recorte',
    icon: FcAlarmClock,
    to: 'novo-recorte',
  },
];

const missionItems = [
  {
    title: 'Missão, Visão e Valores',
    description: 'Venha conhecer nosso propósito',
    icon: FcAbout,
    to: 'proposito',
  },
];

const contactItems = [
  {
    title: 'Contato',
    description: 'Aguardamos seu contato',
    icon: FcPhone,
    to: 'contato',
  },
];

const mapNotifications = item => ({
  id: item.id,
  image: null,
  title: item.title,
  description: item.text.substr(0, 120) + '...',
  createdAt: new Date(item.createdAt),
});

function Navbar() {
  const [user, setUser] = useState(null);
  const { ref, isActive, toggleIsActive } = useClickAway();
  const { subpoenas, isLoading, unread } = useSubpoenaList();
  const scrollDirection = useScrollDirection();
  const isMobile = useIsMobile();

  useLayoutEffect(() => {
    const loggedUser = localStorage.getItem('user');

    if (loggedUser) {
      setUser(JSON.parse(loggedUser));
    }
  }, []);

  const logoComponent = (
    <LogoContainer>
      <Link className="link" to="/">
        <img className="img" src={logo} alt="Juslabore Logo" />
        <span className="title">Juslabore</span>
      </Link>
    </LogoContainer>
  );

  return (
    <Container
      scrollDirection={scrollDirection}
      isMenuActive={!isMobile || isActive}
      ref={ref}
    >
      <div className="nav-menus">
        {isMobile && (
          <div className="hamburger-container">
            {logoComponent}
            <div className="hamburger" onClick={toggleIsActive}>
              <GiHamburgerMenu />
            </div>
          </div>
        )}

        <div className="menu-container">
          <div className="menu">
            {!isMobile && logoComponent}

            <SuperSubMenu text="Ferramentas">
              <SubMenuContainer>
                <IconList title="Recorte" items={clippingItems} />
              </SubMenuContainer>
            </SuperSubMenu>

            <SuperSubMenu text="Sobre">
              <SubMenuContainer>
                <IconList title="Propósito" items={missionItems} />
                <IconList title="Contato" items={contactItems} />
              </SubMenuContainer>
            </SuperSubMenu>
          </div>

          <div className="menu">
            <NavbarLink callToAction to="/acesso">
              Teste Grátis
            </NavbarLink>

            {user && (
              <SimpleSubMenu
                text={
                  <NavbarLink label={unread}>
                    {isMobile ? 'Notificações' : <FaBell />}
                  </NavbarLink>
                }
              >
                <Notifications
                  items={subpoenas.map(mapNotifications)}
                  isLoading={isLoading}
                />
              </SimpleSubMenu>
            )}

            {user && <LoggedUser user={user} />}
            {!user && (
              <NavbarLink to="/acesso" callToAction isActive>
                Login
              </NavbarLink>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
}

const LoggedUser = ({ user }) => (
  <SimpleSubMenu
    text={
      <LoggedUserContainer>
        {user.image && (
          <img
            className="avatar"
            src={user.image}
            alt="Avatar do usuário logado"
          />
        )}
        {!user.image && (
          <span className="avatar-icon">
            {user.name.substr(0, 1).toUpperCase()}
          </span>
        )}
        <span className="title">Minha conta</span>
      </LoggedUserContainer>
    }
  >
    <MenuList
      links={[
        {
          to: '/perfil',
          text: 'Perfil',
        },
        {
          to: '/logout',
          text: 'Sair',
        },
      ]}
    />
  </SimpleSubMenu>
);

export default Navbar;
